import { Button, Stack, useTheme } from '@mui/material';

const providers = {
  YUSEN: [
    'rifat.Koxha@fr.yusen-logistics.com',
    'loicgranet@hoortrade.com',
    'mehdy.bouzigh@fr.yusen-logistics.com',
    'theocuadrado@hoortrade.com',
    'romaincharalambos@hoortrade.com',
    'jeanphilippejanier@hoortrade.com',
    'audedaniel@hoortrade.com',
    'laveniyabossuge@hoortrade.com',
    'ummuye.yilmaz@fr.yusen-logistics.com',
    'valentin.arckx@fr.yusen-logistics.com',
    'audrey.marmonnier@fr.yusen-logistics.com',
  ],
  DPD: [
    'general.238@dpd.fr',
    'christelle.sebelin@dpd.fr',
    'jeanphilippejanier@hoortrade.com',
  ],
  UPS: ['preferredfr@ups.com'],
};

const ServiceProviderReceiverButtons = ({ setReceiverList }) => {
  const theme = useTheme();

  const getButtonStyles = (provider) => {
    switch (provider) {
      case 'YUSEN':
        return {
          backgroundColor: theme.palette.button.YUSEN.main,
          color: theme.palette.getContrastText(theme.palette.button.YUSEN.main),
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '8px 16px',
          fontSize: '12px',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: theme.palette.button.YUSEN.hover,
            boxShadow: '0 6px 10px rgba(0, 0, 0, 0.2)',
            transform: 'scale(1.05)',
          },
          '&:active': {
            backgroundColor: theme.palette.button.YUSEN.active,
            transform: 'scale(0.98)',
          },
        };
      case 'DPD':
        return {
          backgroundColor: theme.palette.button.DPD.main,
          color: '#FFFFFF',
          borderRadius: '8px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '8px 16px',
          fontSize: '12px',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: theme.palette.button.DPD.hover,
            boxShadow: '0 6px 10px rgba(0, 0, 0, 0.2)',
            transform: 'scale(1.05)',
          },
          '&:active': {
            backgroundColor: theme.palette.button.DPD.active,
            transform: 'scale(0.98)',
          },
        };
      case 'UPS':
        return {
          backgroundColor: theme.palette.button.UPS.main,
          color: theme.palette.getContrastText(theme.palette.button.UPS.main),
          borderRadius: '8px',
          fontSize: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          padding: '8px 16px',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          transition: 'all 0.3s ease',
          '&:hover': {
            backgroundColor: theme.palette.button.UPS.hover,
            boxShadow: '0 6px 10px rgba(0, 0, 0, 0.2)',
            transform: 'scale(1.05)',
          },
          '&:active': {
            backgroundColor: theme.palette.button.UPS.active,
            transform: 'scale(0.98)',
          },
        };
      default:
        return {};
    }
  };

  return (
    <Stack direction="row" spacing={1} sx={{ marginTop: '10px' }}>
      {Object.entries(providers).map(([name, receivers]) => (
        <Button
          variant="contained"
          key={name}
          onClick={() => setReceiverList(receivers)}
          sx={getButtonStyles(name)} // Appliquer les styles dynamiques ici
        >
          {name}
        </Button>
      ))}
    </Stack>
  );
};

export default ServiceProviderReceiverButtons;
